"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _constant = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant2 = require("./constant");
var _dropdownOptions = _interopRequireDefault(require("./dropdownOptions.proptypes"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const DropdownOptionsWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__DropdownOptionsWrapper",
  componentId: "sc-13nfszw-0"
})(["display:inline-block;position:relative;"]);
const DropdownOptionsHeader = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__DropdownOptionsHeader",
  componentId: "sc-13nfszw-1"
})(_ref => {
  let {
    theme,
    textSize,
    hoverColor,
    isOpen,
    activeColor,
    hasBottomLine
  } = _ref;
  return "\n    display: inline-flex;\n    padding: ".concat(theme.space.micro, " 0;\n    cursor: pointer;\n\n    & > div {\n      display: inherit;\n      align-items: center;\n    }\n\n    & > p {\n      font-size: ").concat(theme.fontSize[textSize], ";\n    }\n\n    &:hover {\n      ").concat(!isOpen && "\n          & * {\n            color: ".concat(theme.colors[hoverColor], ";\n          }\n        "), "\n    }\n    \n    ").concat(isOpen && hasBottomLine ? "\n        border-bottom: 1px solid ".concat(theme.colors[activeColor], ";\n      ") : null, "\n  ");
});
const DropdownIcon = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__DropdownIcon",
  componentId: "sc-13nfszw-2"
})(["max-width:20px;max-height:20px;margin-right:", ";"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.space.tiny;
});
const DropdownActionIcon = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__DropdownActionIcon",
  componentId: "sc-13nfszw-3"
})(["max-width:20px;max-height:20px;margin-left:", ";"], _ref3 => {
  let {
    dropdownIconGap
  } = _ref3;
  return dropdownIconGap;
});
const getOptionsWrapperPosition = val => {
  if (val === _constant2.DROPDOWN_POSITIONS.RIGHT) {
    return 'right: 0';
  }
  return 'left: 0';
};
const OptionsWrapper = _styledComponents.default.ul.withConfig({
  displayName: "DropdownOptions__OptionsWrapper",
  componentId: "sc-13nfszw-4"
})(_ref4 => {
  let {
    theme,
    backgroundColor,
    dropdownPosition
  } = _ref4;
  return "\n    position: absolute;\n    top: calc(100% + ".concat(theme.space.micro, ");\n    margin: 0;\n    padding: ").concat(theme.space.tiny, " 0;\n    background-color: ").concat(theme.backgroundColor[backgroundColor] || theme.backgroundColor.default, ";\n    border-radius:  ").concat(theme.borderRadius.normal, ";\n    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);\n    list-style-type: none;\n    min-width: 184px;\n    z-index: 999;\n    ").concat(getOptionsWrapperPosition(dropdownPosition), "\n  ");
});
const OptionsList = _styledComponents.default.li.withConfig({
  displayName: "DropdownOptions__OptionsList",
  componentId: "sc-13nfszw-5"
})(_ref5 => {
  let {
    theme,
    backgroundColor,
    textSize,
    hoverBackgroundColor
  } = _ref5;
  return "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ".concat(theme.space.XSmall, ";\n  background-color: ").concat(theme.backgroundColor[backgroundColor], ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover{\n    background-color: ").concat(theme.backgroundColor[hoverBackgroundColor], ";\n  }\n\n  & > p{\n    font-size: ").concat(theme.fontSize[textSize], ";\n  }\n\n  & *{\n    outline: 0;\n  }\n  ");
});
const OptionsIcon = _styledComponents.default.span.withConfig({
  displayName: "DropdownOptions__OptionsIcon",
  componentId: "sc-13nfszw-6"
})(["display:flex;margin-right:", ";"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.space.tiny;
});
const CheckContainer = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__CheckContainer",
  componentId: "sc-13nfszw-7"
})(["display:flex;justify-content:space-between;padding-left:", ";"], _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.space.tiny;
});
const ArrowContainer = _styledComponents.default.div.withConfig({
  displayName: "DropdownOptions__ArrowContainer",
  componentId: "sc-13nfszw-8"
})(["display:flex;flex:1;justify-content:flex-end;"]);
const DropdownOptions = props => {
  const {
    headerLabel,
    headerIcon,
    headerConfig,
    dropDownActionIconConfig,
    hasDropDownActionIcon,
    data,
    dataConfig,
    onOptionSelect,
    defaultSelectedData,
    defaultOpenDropdown,
    dropdownPosition,
    accessible,
    theme,
    customProperties,
    optionsCustomProperties,
    fireGtm,
    gtmEventData,
    dropdownIconColor,
    dropdownIconGap,
    hasSelectedCheckIcon,
    hasBottomLine
  } = props;
  const {
    open,
    close
  } = dropDownActionIconConfig;
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const tabIndex = !accessible ? '-1' : '0';
  const [dropdownOpen, setDropdownOpen] = (0, _react.useState)(defaultOpenDropdown);
  const dropdownOptionsRef = (0, _react.useRef)(null);
  const optionsWrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setDropdownOpen(defaultOpenDropdown);
  }, [defaultOpenDropdown]);
  const optionPopupClickHandler = e => {
    if (!dropdownOptionsRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      if (dropdownOpen) {
        document.addEventListener('click', optionPopupClickHandler);
      } else {
        document.removeEventListener('click', optionPopupClickHandler);
      }
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', optionPopupClickHandler);
      }
    };
  }, [dropdownOpen]);
  const openHandler = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const selectOptionHander = val => {
    if (onOptionSelect) {
      onOptionSelect(val);
    }
    if (fireGtm && gtmEventData) {
      const newData = gtmEventData.replace('{{label}}', val);
      fireGtm(newData);
    }
    setDropdownOpen(false);
  };
  const returnCheckIcon = () => {
    return /*#__PURE__*/_react.default.createElement(CheckContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      fontsize: "titleNormal",
      color: "tertiary",
      icon: "CheckIcon",
      theme: theme
    }));
  };
  const renderOptions = () => {
    // eslint-disable-next-line react/prop-types
    const {
      textColor,
      textSize,
      iconSize,
      backgroundColor,
      hoverBackgroundColor
    } = dataConfig;
    return /*#__PURE__*/_react.default.createElement(OptionsWrapper, (0, _extends2.default)({
      ref: optionsWrapperRef,
      tabIndex: tabIndex,
      backgroundColor: backgroundColor,
      dropdownPosition: dropdownPosition,
      id: "airasia-dropdown-list-wrapper"
    }, optionsCustomProperties),
    // eslint-disable-next-line react/prop-types
    data.map((d, index) => {
      return /*#__PURE__*/_react.default.createElement(OptionsList, {
        key: d.value,
        tabIndex: tabIndex,
        backgroundColor: defaultSelectedData === d.value ? hoverBackgroundColor : backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        textSize: textSize,
        onClick: () => selectOptionHander(d.value),
        onKeyDown: e => _utilities.default.keyDownHandler(e, () => selectOptionHander(d.value), _constant.KEY_CODE.ENTER),
        id: "airasia-dropdown-options-item-".concat(index)
      }, d.icon && /*#__PURE__*/_react.default.createElement(OptionsIcon, {
        id: "airasia-dropdown-options-item-icon-".concat(index)
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        accessible: false,
        fontsize: iconSize,
        color: textColor,
        icon: d.icon,
        theme: theme
      })), /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: false,
        color: textColor,
        theme: theme,
        customProperties: {
          id: "airasia-dropdown-options-item-text-".concat(index)
        }
      }, d.text), d.showArrow && /*#__PURE__*/_react.default.createElement(ArrowContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        accessible: false,
        fontsize: iconSize,
        color: textColor,
        icon: "ChevronRightIcon",
        theme: theme
      })), defaultSelectedData === d.value && hasSelectedCheckIcon ? returnCheckIcon() : null);
    }));
  };
  const optionsWrapperKeyDownHandler = e => {
    if (!dropdownOptionsRef.current.contains(e.relatedTarget)) {
      setDropdownOpen(false);
    }
  };
  const getMain = () => {
    // eslint-disable-next-line react/prop-types
    const aggregatedHeader = {
      ..._dropdownOptions.default.DefaultProps.headerConfig,
      ...headerConfig
    };
    const {
      normalColor,
      hoverColor,
      activeColor,
      textSize,
      iconSize
    } = aggregatedHeader;
    const iconColorValue = dropdownIconColor || normalColor;
    const keyDownHandler = () => {
      openHandler();
      _utilities.default.elementReady('#airasia-dropdown-list-wrapper').then(el => {
        el.focus();
      });
    };
    return /*#__PURE__*/_react.default.createElement(DropdownOptionsWrapper, {
      id: "airasia-dropdown-options-wrapper",
      ref: dropdownOptionsRef,
      onBlur: optionsWrapperKeyDownHandler
    }, /*#__PURE__*/_react.default.createElement(DropdownOptionsHeader, (0, _extends2.default)({
      isOpen: dropdownOpen,
      activeColor: activeColor,
      hoverColor: hoverColor,
      textSize: textSize,
      hasBottomLine: hasBottomLine,
      id: "airasia-dropdown-options",
      tabIndex: tabIndex,
      onClick: keyDownHandler,
      onKeyDown: e => _utilities.default.keyDownHandler(e, keyDownHandler, _constant.KEY_CODE.ENTER)
    }, customProperties), headerIcon && /*#__PURE__*/_react.default.createElement(DropdownIcon, {
      id: "airasia-dropdown-options-left-icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: headerIcon,
      fontsize: iconSize,
      color: dropdownOpen ? activeColor : normalColor,
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      color: dropdownOpen ? activeColor : normalColor,
      theme: theme,
      customProperties: {
        id: 'airasia-dropdown-options-title',
        'aria-hidden': 'true'
      }
    }, headerLabel), hasDropDownActionIcon && /*#__PURE__*/_react.default.createElement(DropdownActionIcon, {
      id: "airasia-dropdown-options-right-icon",
      dropdownIconGap: dropdownIconGap
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: dropdownOpen ? open : close,
      fontsize: iconSize,
      color: dropdownOpen ? activeColor : iconColorValue
    }))), dropdownOpen && renderOptions());
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
DropdownOptions.propTypes = _dropdownOptions.default.PropTypes;
DropdownOptions.defaultProps = _dropdownOptions.default.DefaultProps;
var _default = exports.default = DropdownOptions;